// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"4e392f87","386":"ffff5667","453":"efbd4ee9","838":"dd8e38ea"}[chunkId] + ".chunk.js";
};